import MoneyWordProblem from "../../components/ClassOne/Mathematics/MoneyWordProblem";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


const topics: MenuItem[] = [
    { url: "/class-one/mathematics/money/word-problem", title: "Word Problem", component: MoneyWordProblem },
];

export default topics;